export default class BookingMemberToEventAdditionalPriceDefinition {
    int: number
    bookingMemberId: number
    eventAdditionalPriceDefinitionId: number
}